import React from "react";
import { Link, Popover, SpaceBetween } from "@amzn/awsui-components-react";
import { avatarUrl } from "./UserAvatar";
import "./MentionChip.scss";

/**
 * An @mention of a Lusca Search user: highlighted text that opens a small person card (badge
 * photo, phonetool and e-mail) — the same idea as Taskei's mention popover.
 */
export const MentionChip: React.FC<{ alias: string; text?: string }> = ({
  alias,
  text,
}) => (
  <Popover
    dismissButton={false}
    position="top"
    size="medium"
    triggerType="custom"
    renderWithPortal
    content={
      <div className="mention-card" data-testid="mention-card">
        <img
          className="mention-card__photo"
          src={avatarUrl(alias)}
          alt=""
          loading="lazy"
        />
        <SpaceBetween size="xxs">
          <Link
            external
            href={`https://phonetool.amazon.com/users/${encodeURIComponent(
              alias
            )}`}
          >
            {alias}
          </Link>
          <Link
            external
            fontSize="body-s"
            href={`mailto:${encodeURIComponent(alias)}@amazon.com`}
          >
            {alias}@amazon.com
          </Link>
        </SpaceBetween>
      </div>
    }
  >
    {/* A real button: Enter/Space open the person card like a click does. */}
    <button
      type="button"
      className="mention-chip"
      data-testid="comment-mention"
      title={alias}
    >
      {text ?? `@${alias}`}
    </button>
  </Popover>
);

export default MentionChip;
